var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ZaSpacer",class:_vm.elmClasses,attrs:{"data-debug-label":"ZaSpacer"}},[_c('div',{staticClass:"ZaSpacer__inner"},_vm._l((_vm._rows),function(row,index){return _c('br',{key:index})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }